{
  "familyId": "SWW-VD-HOMOFOON",
  "questions": [
    {
      "id": "SWW-VD-HOMOFOON-001",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "Een journalist schrijft: 'Als ik het ... (weten), had ik het gezegd.' Welke werkwoordsvorm past?",
      "options": ["had geweten", "wist", "weet", "geweten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voltooid Verleden Tijd",
            "content": "Voltooid verleden tijd: had/was + voltooid deelwoord. Voorbeeld: had geweten, was gegaan. Gebruik deze tijd als iets in het verleden al klaar was vóór iets anders.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "all_tenses_mix",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De journalist herkent: de zin beschrijft iets dat in het verleden had kunnen gebeuren ('Als ik het ..., had ik het gezegd'). Dit vraagt om voltooid verleden tijd: had + voltooid deelwoord. Het voltooid deelwoord van 'weten' is 'geweten'. Dus: had geweten.",
        "solutionSteps": [
          "De zin beschrijft iets in het verleden → voltooid verleden tijd",
          "Voltooid verleden tijd = had/was + voltooid deelwoord",
          "Voltooid deelwoord van 'weten' = geweten",
          "Antwoord: had geweten"
        ],
        "distractorExplanations": {
          "0": "Goed! Voltooid verleden tijd: had + voltooid deelwoord = had geweten.",
          "1": "Je dacht waarschijnlijk dat de gewone verleden tijd hier past. Maar 'wist' is de gewone verleden tijd. De constructie 'Als ik het ... had ik ...' vraagt om voltooid verleden tijd: had geweten. Onthoud: 'had ... had' = voltooid verleden tijd.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'weet' is tegenwoordige tijd, terwijl de zin het verleden beschrijft ('had ik het gezegd'). Onthoud: kijk naar de andere werkwoorden in de zin.",
          "3": "Je dacht waarschijnlijk dat 'geweten' alleen genoeg is. Maar de voltooid verleden tijd heeft altijd een hulpwerkwoord nodig: had geweten, niet alleen geweten. Onthoud: voltooid deelwoord gaat altijd samen met had/was."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.vvt-vt-confusion", "label": "Gewone verleden tijd i.p.v. voltooid verleden tijd", "optionIndex": 1 },
          { "id": "sww.tense-confusion-tt-vt", "label": "Tegenwoordige tijd gebruikt in verleden context", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-002",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Lees beide zinsdelen goed. Welk werkwoord is fout? Let op: niet elke vorm zonder -t is verkeerd.",
      "context": "Ik word steeds sterker door te sporten en hij word dat ook.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Ik word steeds sterker door te sporten en hij word dat ook.",
        "correctHighlights": [{"start": 47, "end": 51}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Word vs. Wordt",
            "content": "Bij 'ik' gebruik je alleen de stam: ik word (zonder t). Bij hij/zij/het voeg je -t toe: hij wordt. Vervang door 'smurfen': 'Ik smurf' (niet 'Ik smurft') → dus: ik word.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_ik_compare",
      "variantIndex": 2,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee keer staat er 'word' — maar maar één is fout. Eerste: 'Ik word' = correct (bij ik gebruik je de stam zonder -t). Tweede: 'hij word' = FOUT — bij hij voeg je altijd -t toe: hij wordt. Vergelijk de twee onderwerpen: ik krijgt geen -t, hij krijgt wel -t. Smurfen-check: 'Ik smurf' klinkt goed (= ik word ✓), 'hij smurft' klinkt goed (= hij wordt, dus 'hij word' is fout).",
        "solutionSteps": [
          "Vind beide werkwoord-vormen: 'Ik word' en 'hij word'",
          "Bepaal per zin het onderwerp: ik (1e p.) en hij (3e p.)",
          "Regel: ik = stam zonder -t, hij = stam + -t",
          "Eerste 'word' bij ik = correct ✓",
          "Tweede 'word' bij hij = fout → moet wordt zijn"
        ],
        "distractorExplanations": {
          "1": "Goed! De tweede 'word' (bij hij) is fout — moet wordt zijn. De eerste 'word' (bij ik) is wél correct."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-ik", "label": "Subject-verb mismatch: hij + stam zonder -t" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-003",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "Beide zinsdelen gaan over 'hij'. Welk werkwoord is fout gespeld?",
      "context": "Hij wordt steeds sterker door te sporten en daardoor word hij gezonder.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Hij wordt steeds sterker door te sporten en daardoor word hij gezonder.",
        "correctHighlights": [{"start": 53, "end": 57}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Word vs. Wordt — ook bij inversie",
            "content": "Bij hij/zij/het voeg je -t toe, óók als het werkwoord vóór het onderwerp staat: 'daardoor wordt hij'. Inversie verandert de regel niet.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_inversion_compare",
      "variantIndex": 3,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Beide werkwoorden horen bij 'hij' (3e persoon enkelvoud) en moeten dus stam + -t krijgen. Eerste: 'Hij wordt' = correct ✓. Tweede: 'daardoor word hij' = FOUT — ook bij inversie (werkwoord vóór onderwerp) blijft de regel gelden: 3e persoon krijgt -t, dus 'wordt hij'. De woordvolgorde verandert de regel niet. Smurfen-check: 'daardoor smurft hij' klinkt goed (met -t).",
        "solutionSteps": [
          "Vind beide werkwoorden: 'wordt' en 'word'",
          "Onderwerp van beide = hij (3e persoon enkelvoud)",
          "Regel: 3e persoon enkelvoud krijgt altijd -t, óók bij inversie",
          "Eerste 'wordt' = correct ✓",
          "Tweede 'word' = fout → bij inversie blijft regel: wordt hij"
        ],
        "distractorExplanations": {
          "1": "Goed! 'Word hij' is fout — ook bij inversie blijft de -t-regel: wordt hij. De eerste 'wordt' is wél correct."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-hij", "label": "Inversie genegeerd: -t weggelaten bij werkwoord-vóór-hij" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-004",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "text_highlight",
      "question": "In één zin staat 'word' fout, in de andere is het correct. Klik op de fout.",
      "context": "Het boek word morgen bezorgd. Ik word zenuwachtig van het wachten.",
      "options": [],
      "correctAnswer": 1,
      "data": {
        "text": "Het boek word morgen bezorgd. Ik word zenuwachtig van het wachten.",
        "correctHighlights": [{"start": 9, "end": 13}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Het onderwerp bepaalt de -t",
            "content": "Bij 'het' (3e persoon) voeg je -t toe: het wordt. Bij 'ik' (1e persoon) blijft de stam: ik word. Dezelfde stam, andere vorm — bepaal altijd eerst het onderwerp.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "word_wordt_het_vs_ik_compare",
      "variantIndex": 4,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Twee keer 'word' — maar het onderwerp bepaalt of er een -t bij hoort. Eerste: 'Het boek word' = FOUT — 'het boek' is 3e persoon enkelvoud, dus stam + -t = wordt. Tweede: 'Ik word' = correct ✓ — bij ik gebruik je de stam zonder -t. De regel hangt af van het onderwerp, niet van het woord zelf. Smurfen-check: 'het boek smurft' (met -t), 'ik smurf' (zonder -t).",
        "solutionSteps": [
          "Vind beide 'word'-vormen in de twee zinnen",
          "Bepaal per zin het onderwerp: 'het boek' (3e p.) en 'ik' (1e p.)",
          "Regel: het = stam + -t, ik = stam zonder -t",
          "Eerste 'word' bij het boek = fout → moet wordt zijn",
          "Tweede 'word' bij ik = correct ✓"
        ],
        "distractorExplanations": {
          "1": "Goed! 'Het boek word' is fout — moet wordt zijn. Bij 'ik word' is geen -t nodig."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-het", "label": "Subject-afhankelijke -t-regel niet toegepast bij het/ik-contrast" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-005",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "multiple_choice",
      "question": "Een advocaat schrijft een brief: 'De verdachte ... (worden) vrijgesproken door de rechter.' Welke vorm past?",
      "options": ["werd", "word", "wordt", "geworden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verleden tijd van 'worden'",
            "content": "De verleden tijd van 'worden' is: ik/hij/zij werd, wij/zij werden. 'De verdachte' = hij/zij → werd. Let op: 'werd' (enkelvoud) vs. 'werden' (meervoud).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "worden_past_tense",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De advocaat herkent: de zin beschrijft iets in het verleden (vrijgesproken door de rechter). 'De verdachte' = hij/zij → verleden tijd enkelvoud: werd. Niet 'word' (stam) of 'wordt' (tegenwoordige tijd).",
        "solutionSteps": [
          "De zin beschrijft het verleden → verleden tijd",
          "'De verdachte' = hij/zij → enkelvoud",
          "Verleden tijd enkelvoud van 'worden' = werd",
          "Antwoord: De verdachte werd vrijgesproken"
        ],
        "distractorExplanations": {
          "0": "Goed! De verleden tijd enkelvoud van 'worden' is 'werd'.",
          "1": "Je dacht waarschijnlijk dat de stam hier past. Maar 'word' is de stam (ik-vorm tegenwoordige tijd). De zin beschrijft het verleden, dus: werd. Onthoud: kijk of de zin over het verleden gaat.",
          "2": "Je dacht waarschijnlijk dat de tegenwoordige tijd hier past. Maar 'wordt' is tegenwoordige tijd. De zin beschrijft iets dat al gebeurd is (vrijgesproken), dus verleden tijd: werd. Onthoud: 'vrijgesproken' wijst op het verleden.",
          "3": "Je dacht waarschijnlijk dat het voltooid deelwoord hier past. Maar 'geworden' hoort bij 'is geworden'. Hier staat geen hulpwerkwoord 'is', dus gewoon verleden tijd: werd. Onthoud: voltooid deelwoord = altijd met hulpwerkwoord."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.tense-context-ignored", "label": "Tijdcontext genegeerd (stam i.p.v. VT)", "optionIndex": 1 },
          { "id": "sww.tense-confusion-tt-vt", "label": "TT (wordt) i.p.v. VT (werd) in verleden context", "optionIndex": 2 },
          { "id": "sww.vd-without-aux", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-006",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "werkwoorden",
      "subSkill": "ww_vd_homofoon",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst. Tik op een fout woord en typ de verbetering.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De jongen word altijd opgehaald door zijn moeder. Gisteren heefd hij zelf gefietst. Hij vind dat veel leuker.",
        "errors": [
          { "word": "word", "position": 2, "correction": "wordt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (wordt)" },
          { "word": "heefd", "position": 10, "correction": "heeft", "rule": "Onregelmatig werkwoord hebben: hij heeft" },
          { "word": "vind", "position": 15, "correction": "vindt", "rule": "Tegenwoordige tijd, 3e persoon: stam + t (vindt)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam + t bij hij/zij/het",
            "content": "Bij hij, zij of het in de tegenwoordige tijd gebruik je altijd de stam + t. Dus: hij wordt, hij vindt. Ook als de stam al op een -d eindigt!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "homofoon_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij 'hij' of 'de jongen' gebruik je in de tegenwoordige tijd altijd de stam + t. Dus: hij wordt, hij vindt. Het werkwoord 'hebben' is onregelmatig: hij heeft (niet heefd).",
        "solutionSteps": [
          "De jongen (hij) + worden (tegenwoordige tijd) = wordt",
          "Hij + hebben = heeft",
          "Hij + vinden (tegenwoordige tijd) = vindt"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.stam-plus-t-vergeten", "label": "Stam + t vergeten bij 3e persoon enkelvoud" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-011",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "error_spotting",
      "question": "Vind de werkwoordspellingfouten in deze tekst. Let op: word/wordt, vind/vindt, verwart/verward.",
      "correctAnswer": null,
      "data": {
        "text": "Hij word steeds beter in spelling. Ze heeft het antwoord al gevonden, maar ze vind het moeilijk om uit te leggen. Het probleem wordt nu opgelost.",
        "errors": [
          { "word": "word", "correction": "wordt", "startIndex": 3, "endIndex": 7, "explanation": "Bij 'hij' in de tegenwoordige tijd: stam + t. Word + t = wordt." },
          { "word": "vind", "correction": "vindt", "startIndex": 86, "endIndex": 90, "explanation": "Bij 'ze' (enkelvoud) in de tegenwoordige tijd: stam + t. Vind + t = vindt." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Homofonen: word/wordt, vind/vindt", "content": "Ik word (geen t), hij/zij wordt (wel t). Ik vind (geen t), hij/zij vindt (wel t). Check: vervang door een ander werkwoord. 'Hij loop' klinkt fout → 'hij loopt' → dus ook 'hij wordt'.", "icon": "lightbulb" } }
      ],
      "conceptId": "homofoon_error_spotting",
      "variantIndex": 11,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Twee fouten: 1) 'Hij word' → 'Hij wordt' (hij + stam + t). 2) 'ze vind' → 'ze vindt' (zij + stam + t). De laatste zin is correct: 'Het probleem wordt' (het + stam + t).",
        "solutionSteps": [
          "Check elk werkwoord: wie is het onderwerp?",
          "'Hij word' → hij = 3e persoon → wordt (stam + t)",
          "'ze vind' → zij = 3e persoon → vindt (stam + t)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.stam-plus-t-vergeten", "label": "Stam-t vergeten in tegenwoordige tijd 3e persoon" }
        ]
      }
    },
    {
      "id": "SWW-VD-HOMOFOON-012",
      "familyId": "SWW-VD-HOMOFOON",
      "module": "SpellingWW",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "voltooid_deelwoord",
      "subSkill": "vd_pv_verwarring",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in de tegenwoordige tijd in: 'Het boek dat ik gisteren heb besteld, ___ (worden) morgen bezorgd.' Let op: kijk goed wat het onderwerp is.",
      "correctAnswer": "wordt",
      "data": {
        "acceptedAnswers": ["wordt"],
        "placeholder": "word of wordt?",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Onderwerp vinden in een lange zin", "content": "Bij een zin met een bijzin (zoals 'dat ik gisteren heb besteld') zit het echte onderwerp vóór die bijzin. Lees de zin zonder de bijzin: 'Het boek ___ morgen bezorgd.' Onderwerp = het boek (3e p.) → stam + t = wordt.", "icon": "lightbulb" } }
      ],
      "conceptId": "homofoon_fill_in_subject_distance",
      "variantIndex": 12,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De bijzin 'dat ik gisteren heb besteld' is een afleider — daarin staat 'ik', maar dat is NIET het onderwerp van het hoofdwerkwoord. Lees de zin zonder de bijzin: 'Het boek ___ morgen bezorgd.' Het echte onderwerp is 'het boek' (3e persoon enkelvoud). Bij hij/zij/het: stam + -t = wordt. Handige tip: zet altijd haakjes om de bijzin om de hoofdzin overzichtelijk te maken.",
        "solutionSteps": [
          "Lees de hele zin en zoek de bijzin tussen komma's: 'dat ik gisteren heb besteld'",
          "Haal de bijzin weg: 'Het boek ___ morgen bezorgd.'",
          "Echte onderwerp = 'het boek' (3e persoon enkelvoud, niet 'ik')",
          "Regel: 3e persoon TT → stam + -t = wordt",
          "Antwoord: wordt"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.word-wordt-het", "label": "Bijzin-afleider gevolgd: 'ik' uit bijzin als onderwerp gekozen" }
        ]
      }
    }
  ]
}